// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__UsspR","hiddenElements":"Header_hiddenElements__E0msf","search":"Header_search__3s9Th","dark":"Header_dark__1gZTh","wrapper":"Header_wrapper__36tII"};